<template>
  <div id="app">
	<!--<header>  
		<div class="global-header">
			<div class="grid-wrap">
				<div class="grid-row">
					<div class="grid-col grid-col--soft grid-xsmall-9 grid-medium-8">
						<div class="global-header__title">
							Adult MSK Physiotherapy
						</div>
					</div>            
				</div>            
			</div>
		</div>
	</header>-->
	<main id="main">
		<router-view :key="$route.fullPath"></router-view>
	</main>
  </div>
</template>

<script>
import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
	
Vue.use(VueRouter);
Vue.use(Vuex);

export default {
  name: 'App'
}
</script>
